// router/index.js
import Vue from 'vue';
import VueRouter from 'vue-router';

import MyLogin from '../components/MyLogin.vue';
import store from "@/store";
import { Message } from 'element-ui'; // 导入 Element UI 的 Message 组件

Vue.use(VueRouter);

// 路由配置
const routes = [
    {
        path: '/',
        component: MyLogin,
        meta: { requiresAuth: false ,
            title: "后台管理登录"},
    },
    // {
    //     path: '/order',
    //     component: () => import("../views/UserOrder.vue"),
    //     meta: { requiresAuth: false ,
    //             title: "信息学院志愿服务报名"
    //     },
    // },
    {
        path: "/index",
        name: "MyIndex",
        component: () => import("../components/MyIndex.vue"),
        meta: { requiresAuth: true ,
            title: "信息学院志愿服务后台管理"},
        children: [
            {
                path: "/home",
                name: "MyHome",
                component: () => import("../components/MyHome.vue"),
                meta: { requiresAuth: true ,
                    title: "信息学院志愿服务后台管理"},
            },
            {
                path: "/addstudents",
                name: "AddStudents",
                component: () => import("../components/admin/mutiAdd.vue"),
                meta: { requiresAuth: true ,
                    title: "信息学院志愿服务后台管理"},
            },
            {
                path: "/urecords",
                name: "UserRecords",
                component: () => import("../components/admin/UserRecords.vue"),
                meta: { requiresAuth: true ,
                    title: "信息学院志愿服务后台管理"},
            },
            {
                path: "/items",
                name: "ItemsCreate",
                component: () => import("../components/admin/ItemsCreate.vue"),
                meta: { requiresAuth: true ,
                    title: "信息学院志愿服务后台管理"},
            },

            {
                path: "/newitem",
                name: "ItemCreate",
                component: () => import("../components/admin/ItemCreate.vue"),
                meta: { requiresAuth: true ,
                    title: "信息学院志愿服务后台管理"},
            },
            // 移动版页面配置
            {
                path: '/urecords-mobile',
                component: () => import("../components/admin/UserRecordsMobile.vue"),
                meta: { requiresAuth: true ,
                    title: "信息学院志愿服务后台管理"},
            },
            {
                path: '/newitem-mobile',
                component: () => import("../components/admin/ItemCreateMobile.vue"),
                meta: { requiresAuth: true ,
                    title: "信息学院志愿服务后台管理"},
            },
        ]
    },

];

const router = new VueRouter({
    mode: 'history',
    routes
});

// 全局前置守卫
router.beforeEach((to, from, next) => {
    const token = store.getters.getToken; // 获取 Token
    // 1) 已登录用户访问登录页 -> 重定向到内部页
    if ((to.path === '/' || to.name === 'Login') && token) {
        return next('/items'); // 或者 '/index/home'
    }

    // 如果路由的 meta.requiresAuth 为 true，表示需要验证 Token
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!token) {
            Message.error("未登录，请登录！");
            next({ path: '/' }); // 没有 Token，跳转到登录页面
        } else {
            next(); // 有 Token，继续路由导航
        }
    } else {
        next(); // 不需要验证 Token，直接继续路由导航
    }
});

export default router;
